import React, { Fragment, useEffect, useState } from 'react'
import authQueries from '../../../queries/authQueries'
import { Link } from 'react-router-dom'
import LoaderCommon from '../../Common/LoaderCommon'
import moment from 'moment';
import { Empty } from 'antd';
import {getCurrentFinancialYear, getNextFinancialYear, getPreviousFinancialYear} from '../../Common/financialYear';
import { IconTrophy } from '@tabler/icons-react';
  
const TopPerformerScreen = () => {

    const today = new Date()
    const [result, setResult] = useState([])
    const [dateRange, setDateRange] = useState("CURRENT")
    const [fromDate, setFromDate] = useState(today)
    const [toDate, setToDate]= useState(today)

    const currentFinancialYear = getCurrentFinancialYear()
    const nextFinancialYear = getNextFinancialYear()
    const previousFinancialYear = getPreviousFinancialYear()

    const topPerformListing = authQueries.useTopPerformListingMutation(
        (res)=>{
            setResult(res)
        }
    )

    useEffect(()=>{
        topPerformListing.mutateAsync({from: fromDate, to: toDate, type: dateRange })
    },[])

    const onSearch =()=>{
        topPerformListing.mutateAsync({from: fromDate, to: toDate, type: dateRange })
    }

    const selectDate=(e)=>{
        setDateRange(e.target.value)
    }

  return (
    <div>

        <div className="breadcrumb-and-otherbuttons">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Top Performing Counselors</li>
                </ol>
            </nav>
        </div>
            
        <div className="add_clients">
            <div className="flex items-center gap-[4px] mb-4">
                <i className="followup-icon">
                    <IconTrophy size="25" className='text-[#7D6FAB]' />
                </i>
                <div style={{display:'flex', flexDirection:'column'}}>
                    <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                        <span className="text-[16px] font-medium">Top Performing Counselors</span>	
                    </div>
                </div>
            </div>
            <div id="accordion" className="add_clients_accordion_form">
                <div className="card" id="appointments_wrpr">
                    <div className="card-header">
                        Top Performing Counselors
                    </div>
                    <div id="appointment_any" className="collapse show" data-parent="#accordion">
                        <div className="card-body">
                            <div className="row ">
                                <div className="col-md-12">
                                    <div className="table-list-search-wrpr table-report-ceo overflow-auto">
                                        <div className="row">
                                            <div className="col-md-6">
                                            </div>
                                            <div className="col-md-6 text-right">
                                        </div>
                                    </div>
                                    <div className='grid grid-cols-12 gap-4 max-[1446px]:grid-cols-10 max-[1094px]:grid-cols-8 max-[949px]:grid-cols-6 max-[640px]:grid-cols-4 max-[483px]:grid-cols-2 !w-full mb-4'>
                                        <div className='col-span-3'>
                                            <label>Select Date</label>
                                            <select value={dateRange} className='form-control form-control-sm !w-full !min-h-[38px]' onChange={selectDate}>
                                                <option value="PREVIOUS">Previous Financial Year ({previousFinancialYear})</option>
                                                <option value="CURRENT">Current Financial Year ({currentFinancialYear})</option>
                                                <option value="FUTURE">Next Financial Year ({nextFinancialYear})</option>
                                                <option value="CUSTOM">Custom Date</option>
                                            </select>
                                        </div>
                                        {dateRange === "CUSTOM" &&
                                            <Fragment>
                                                <div className='col-span-2'>
                                                    <label>From Date</label>
                                                    <input 
                                                    max={moment(toDate).format("YYYY-MM-DD")} 
                                                    value={moment(fromDate).format('YYYY-MM-DD')} 
                                                    type='date' onChange={(e)=> {setFromDate(e.target.value)}} 
                                                    className='form-control form-control-sm !w-full !min-h-[38px]' 
                                                    />
                                                </div>
                                                <div className='col-span-2'>
                                                    <label>To Date</label>
                                                    <input 
                                                    min={moment(fromDate).format("YYYY-MM-DD")} 
                                                    value={moment(toDate).format('YYYY-MM-DD')} 
                                                    type='date' onChange={(e)=> {setToDate(e.target.value)}} 
                                                    className='form-control form-control-sm !w-full !min-h-[38px]' 
                                                    />
                                                </div>
                                            </Fragment>
                                        }
                                        <div className='col-span-1 flex flex-col'>
                                            <label>&nbsp;</label>
                                            <button onClick={onSearch} className='mt-[3px] rounded-md text-[12px] !w-full !min-h-[38px] bg-[#323a51] border-none text-white'>
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                    {topPerformListing?.isLoading ?
                                        <LoaderCommon />:
                                        <Fragment>
                                            {
                                                result?.data?.length > 0 ?
                                                <table border={1} className="table report collageprogram">
                                                    <thead>
                                                        <tr>
                                                            <th>Sl No</th>
                                                            <th className='min-w-[200px]'>Branch Name</th>
                                                            <th className='min-w-[300px]'>Counselor Name</th>
                                                            <th>Total Visa</th>
                                                            {
                                                                result?.country?.map((item, index)=>(
                                                                    <th className='text-center'>{item}</th>
                                                                ))
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody className="ui-sortable">
                                                        {
                                                            result?.data?.map((item, index)=>(
                                                                <tr key={index}>
                                                                    <td className='!text-[12px]'>{index+1}</td>
                                                                    <td className='!text-[12px]'>{item?.office?.length > 0 && item?.office[0].office?.name }</td>
                                                                    <td className='!text-[12px]'>{item?.name}</td>
                                                                    <td className='!font-bold !text-[12px] text-center'>
                                                                        <TotalFind counselor={item} />
                                                                    </td>
                                                                    {
                                                                        result?.country?.map((items, indexes)=>(
                                                                            <td className='!font-bold !text-[12px] text-center'>
                                                                                <CountryFilter key={indexes} country={items} counselor={item} />
                                                                            </td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr>
                                                            <td colSpan={3} className='text-center text-[14px] font-bold'>Total</td>
                                                            <td className='!font-bold !text-[12px] text-center'>
                                                                <GrandTotal counselor={result} />
                                                            </td>
                                                            {
                                                                result?.country?.map((item, index)=>(
                                                                    <td className='!font-bold !text-[12px] text-center'>
                                                                        <GrandTotalCountry key={index} country={item} counselor={result} />
                                                                    </td>
                                                                ))
                                                            }
                                                        </tr>
                                                    </tbody>

                                                </table>:
                                                <div className='mt-28 mb-28'>
                                                    <Empty description={<div className="text-sm font-poppins">No data found!</div>} />
                                                </div>
                                            }
                                        </Fragment>
                                    }
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      
    </div>
  )
}

export default TopPerformerScreen


const CountryFilter =({country, counselor})=>{
    const count = counselor?.country?.find(item=>item.name === country)
    return count.count
}

const TotalFind =({counselor})=>{
    let newCount = 0
    for(let element of counselor?.country){
        newCount += element.count
    }
    return newCount
}

const GrandTotalCountry =({country, counselor})=> {
    const [total, setTotal] = useState(0)
    useEffect(() => {
        let arr = 0
        counselor?.data?.forEach(item => {
            item?.country.forEach(element => {
                if(element.name === country){
                    arr += element.count
                }
            });
        })
        setTotal(arr)
    }, []);
    return total
}

const GrandTotal =({counselor})=> {
    const [total, setTotal] = useState(0)
    useEffect(() => {
        let arr = 0
        counselor?.data?.forEach(item => {
            item?.country.forEach(element => {
                arr += element.count
            });
        })
        console.log(arr)
        setTotal(arr)
    }, []);
    return total
}